import LiveSwitcher from './LiveSwitcher';

export default LiveSwitcher;
